import React, { FC, PropsWithChildren, useEffect } from "react";
import { initSentry } from "shared-services";
import { getJwtClaims, useAuth } from "shared-auth";

interface Props {
  appName: string;
}

const ErrorTrackingProvider: FC<PropsWithChildren<Props>> = ({
  appName,
  children,
}) => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      initSentry(getJwtClaims(), appName);
    }
  }, [isAuthenticated, appName]);

  return <>{children}</>;
};

export default ErrorTrackingProvider;
